/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import { ModalHeader } from 'reactstrap';
import useForm from '../../hooks/useForm';
import Form from '../Form';
import { useSelector } from 'react-redux';

const EmailSendModal = ({ open, setOpen, submit }) => {
  const { employee, user } = useSelector((store) => ({
    employee: store.Profile.employee,
    user: store.Profile.user
  }));
  const [fields] = useState([{
    key: "email",
    title: "이메일 주소",
    type: "input",
    required: true,
    validators: ['email']

  }]);
  const cancel = () => {
    setOpen(false);
  };

  const _submit = () => {
    submit(form.email);
  };

  const {
    form, setForm,
    handleOnChange,
    handleSubmit,
    errors,
    setValidateFields,
  } = useForm({
    email: employee.email || user.email || ""
  }, _submit);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);


  return (
    <Modal isOpen={open} close={cancel} size="md">
      <ModalHeader>다운로드파일 메일로 받기</ModalHeader>
      <div>
        <p>입출금 내역이 많아 다운로드 대신 메일로 대체합니다.</p>
        <p>하단에 작성하신 메일 수신함 확인 부탁드립니다.</p>
      </div>
      <Form
        form={form}
        errors={errors}
        isRequiredShow={true}
        setForm={setForm}
        fields={fields}
        onChange={handleOnChange}
        submitText={"메일전송요청"}
        submit={handleSubmit}
        cancel={cancel}
      />
    </Modal>
  );
};

export default EmailSendModal;